import React from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import Button from "../../../..//Elements/Button/Button.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useToasts } from "react-toast-notifications";
import config from "config";
import ToastHtmlComponent from "../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import { defaultFormImages } from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import getAsyncImage from "utils/getAsyncImage.js";

const DuplicateForm = ({
  setDynamicFormsList,
  dynamicFormsList,
  formId,
  culture,
  setLoadingFormId,
}) => {
  const { closeModal } = useModal();
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();

  //Copy Form
  const copyForm = async () => {
    setLoadingFormId((prev) => [...prev, formId]);
    closeModal();
    const requestBody = {
      Embed_Dynamic_Id: formId,
      Embed_Dynamic_Culture: culture,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CopyFormReact",
      requestBody,
      "POST"
    );
    if (response.status === "success") {
      if (response.data.Result === 0) {
        getEmbedDynamicForm(response.data.Embed_Dynamic_Id);
      } else {
        let errText = getTextByKey("api-error");
        errText = errText.replace("#ERRORNUM#", response.data.Result);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        errText = errText.replace("#SYSMAIL#", config.supportmail);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        addToast(<ToastHtmlComponent htmlStr={errText} />, {
          appearance: "error",
        });
      }
    } else {
    }

    setLoadingFormId((prev) => prev.filter((id) => id !== formId));
  };

  //Get Embedform to show after coping
  const getEmbedDynamicForm = async (id) => {
    const parameters = {
      formId: id,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedFormReact",
      parameters
    );
    if (response.status === "success") {
      let newForm = response.data;
      const callBackImage = (image) => {
        newForm.Embed_Dynamic_Image = image;
      };

      if (!newForm.Embed_Dynamic_Image) {
        await getAsyncImage(
          `images/${defaultFormImages[dynamicFormsList.length + 1]}.webp`,
          callBackImage
        );
      }

      let newList = [...dynamicFormsList];
      newList.unshift(newForm);
      setDynamicFormsList(newList);
      addToast(getTextByKey("jumboforms-duplicate-success"), {
        appearance: "success",
      });
    } else {
    }
  };

  return (
    <div className="duplicate-form-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <p>{getTextByKey("jumboforms-duplicate-confirm")}</p>
            </div>
            <div className="actions">
              <Button
                buttonClass="duplicate-form-button"
                onClick={() => {
                  copyForm();
                }}
              >
                {getTextByKey("jumboforms-duplicate-tooltip")}
              </Button>
              <Button
                buttonClass="duplicate-form-button blank"
                blank
                onClick={() => {
                  closeModal();
                }}
              >
                {getTextByKey("jumboforms-delete-form-cancel")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default DuplicateForm;
